import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL } from '../consts';
import { IGetDraftResponse, IGetEditOrderDataResponse, ISaveOrderDraftRequest } from '../types';

export const ordersAPI = createApi({
  reducerPath: 'ordersAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL + '/api/v2',
  }),
  endpoints: (build) => ({
    getDraft: build.query<IGetDraftResponse, string>({
      query: (orderId) => ({
        url: `/client/orders/drafts/${orderId}`,
        method: 'get',
      }),
    }),

    getEditOrderData: build.query<IGetEditOrderDataResponse, string>({
      query: (token) => ({
        url: '/client/orders/data/edit',
        method: 'get',
        params: { token },
      }),
    }),

    setOrder: build.mutation<unknown, FormData>({
      query: (payload) => ({
        url: '/client/orders',
        method: 'post',
        body: payload,
      }),
    }),

    editOrder: build.mutation<unknown, FormData>({
      query: (payload) => ({
        url: '/client/orders/edit',
        method: 'post',
        body: payload,
      }),
    }),

    saveOrderDraft: build.mutation<unknown, ISaveOrderDraftRequest>({
      query: (payload) => ({
        url: '/client/orders/drafts',
        method: 'post',
        body: payload,
      }),
    }),
  }),
});

export const {
  useSetOrderMutation,
  useSaveOrderDraftMutation,
  useGetDraftQuery,
  useLazyGetDraftQuery,
  useGetEditOrderDataQuery,
  useLazyGetEditOrderDataQuery,
  useEditOrderMutation,
} = ordersAPI;

export const { setOrder, saveOrderDraft, getDraft, getEditOrderData, editOrder } =
  ordersAPI.endpoints;
